/* Base translations · W13 worksheet — moved unchanged out of lib/i18n.js (STEP 2 · B2).
   Top-level keys owned by this file (no other base file and not i18n.js define them): w13. */
export const I18N_BASE_W13 = {
  en: {
    w13: {
      title: "Audit trail", subtitle: "Every action on this engagement (W13).",
      entityDeleted: "(deleted)",
      retention: "Audit trail retention period",
      retentionYears: "{n} year(s)",
      retentionNotSet: "Not set — the Firm Admin has not yet chosen a retention period. The app never auto-deletes.",
      filters: "Filters",
      f: { user: "User", userAll: "All users",
             action: "Action", actionAll: "All actions",
             ref: "Ref / entity id",
             from: "From date", to: "To date", search: "Search" },
      rowCount: "{n} row(s)",
      exportXlsx: "Export .xlsx", exportCsv: "Export .csv",
      exportedOk: "Exported {n} row(s).",
      reasonPrompt: "Reason for deleting this audit trail entry (required):",
      deletedOk: "Audit trail entry deleted.",
      noRows: "No rows match the filters.",
      deletionsTitle: "Deleted entries (Partner view)",
      h: { at: "When", user: "User", role: "Role", action: "Action",
             entity: "Entity", actions: "",
             deletedAt: "Deleted at", by: "By", reason: "Reason",
             entrySnap: "Original entry" },
      changedAfterSigning: "Audit trail changed after signing",
      changedAfterSigningDetail: "{n} audit-trail entry(ies) covered by this signed bundle were deleted after the sign-off date.",
      action: {
        // N1 — every action_type seen in `audit_trails` (all engagements).
        // A safe fallback in the UI turns any unmapped code into
        // Title-cased words, so a raw code can never render.
        // T2 · 311(a) log actions (nested here so the actionLabel()
        // lookup t("w13.action.<code>") resolves; the flat-key form
        // added in Round S was a top-level literal with dots in it
        // that the dot-path resolver never walks into).
        tcwg_311a_log_added: "311(a) log row added",
        tcwg_311a_log_patched: "311(a) log row edited",
        tcwg_311a_log_backfilled: "Backfilled — original audit write failed",
        tcwg_311a_migrated_from_form: "311(a) row migrated from form section 3",
        tcwg_311a_na_set: "TCWG communication marked N/A",
        tcwg_311a_na_cleared: "TCWG N/A cleared",
        form_na_toggled: "Form N/A toggled",
        ai_cost_rate_updated: "AI cost rate updated",
        ai_key_issued: "AI key issued",
        ai_key_requested: "AI key requested",
        ai_key_rotated: "AI key rotated",
        amended: "Amended",
        assembly_complete: "Assembly marked complete",
        assertion_bypassed: "Assertion bypassed",
        assertion_cleared: "Assertion cleared",
        assertion_ticked: "Assertion ticked",
        bulk_ai_suggested: "Bulk AI suggested",
        bypassed_missing_doc: "Bypassed missing doc",
        cleared_bypass: "Cleared bypass",
        confirmation_created: "Confirmation created",
        confirmation_deleted: "Confirmation deleted",
        confirmation_updated: "Confirmation updated",
        continuous_preset_created: "Continuous preset created",
        continuous_preset_deleted: "Continuous preset deleted",
        created: "Created",
        deduped_population: "Deduped population",
        deleted: "Deleted",
        engagement_member_added: "Engagement member added",
        engagement_member_removed: "Engagement member removed",
        flagged_test_entry: "Flagged test entry",
        form_added_to_engagement: "Form added to engagement",
        form_ai_suggested: "Form AI-suggested",
        form_approved: "Form approved",
        form_deleted_permanent: "Form deleted (permanent)",
        form_draft: "Form set to Draft",
        form_na_toggled: "Form N/A toggled",
        form_ready_for_review: "Form ready for review",
        form_updated: "Form updated",
        forms_batch_added: "Forms batch added",
        forms_rolled_forward: "Forms rolled forward",
        "fs_custom_code.created": "Custom FS code created",
        fs_mapping_clear: "FS mapping cleared",
        fs_mapping_import: "FS mapping imported",
        grade_created: "Billing grade created",
        grade_deleted: "Billing grade deleted",
        imported: "Imported",
        invited: "Invited",
        linked: "Linked",
        member_budget_updated: "Member budget updated",
        migrated: "Migrated",
        moved: "Moved",
        note_mapping_clear: "Note mapping cleared",
        opened_worksheet: "Opened worksheet",
        closed_worksheet: "Closed worksheet",
        orphan_sweep_report: "Orphan sweep report",
        other_cost_created: "Other cost created",
        password_reset_completed: "Password reset completed",
        password_reset_requested: "Password reset requested",
        plan_changed: "Plan changed",
        platform_admin_list_engagements: "Platform admin listed engagements",
        post_assembly_amendment: "Post-assembly amendment",
        ran_detection: "Ran detection",
        rate_updated: "Rate updated",
        renumbered: "Renumbered",
        rerun: "Rerun",
        resampled: "Resampled",
        review_point_cleared: "Review point cleared",
        review_point_comment_added: "Review point comment added",
        review_point_created: "Review point created",
        review_point_deleted: "Review point deleted",
        review_point_in_progress: "Review point in progress",
        review_point_permission_granted: "Review point permission granted",
        review_point_reopened: "Review point reopened",
        review_point_resolved: "Review point resolved",
        roles_renamed: "Roles renamed",
        seeded: "Seeded",
        sent: "Sent",
        sent_to_misstatements: "Sent to misstatements",
        sent_to_sampling: "Sent to sampling",
        signed_off: "Signed off",
        unlocked: "Unlocked",
        stage_signoff_eqc: "EQ reviewer stage sign-off",
        dc_ai_premark_queued: "Disclosure checklist AI pre-mark started", ai_readout_queued: "AI Readout started", risk_ai_suggest_queued: "AI suggest risks started",
        dc_fs_uploaded: "Financial statements uploaded for the disclosure checklist", aging_ap: "Payables aging uploaded", aging_ar: "Receivables aging uploaded",
        head_folder_worksheet_pye: "Period-end worksheet added to a head folder", dc_scoped_out: "Disclosure checklist scoped out", dc_scope_reverted: "Disclosure checklist scope marked applicable",
        bulk_ai_suggested: "Forms AI suggest run", dc_ai_premark_withdrawn_non_fs: "Pre-mark suggestions withdrawn (not FS-based)",
        stage_signoff_partner: "Partner stage sign-off",
        stage_signoff_preparer: "Preparer stage sign-off",
        stage_signoff_reviewer: "Reviewer stage sign-off",
        storage_reconcile_started: "Storage reconcile started",
        tenant_byok_permission_toggled: "Tenant BYOK permission toggled",
        tenant_created: "Tenant created",
        tested: "Tested",
        time_entry_deleted: "Time entry deleted",
        time_entry_edited: "Time entry edited",
        time_manual_added: "Time entry (manual) added",
        undone: "Undone",
        untested: "Untested",
        update: "Update",
        updated: "Updated",
        uploaded: "Uploaded",
        upserted: "Upserted",
        user_grade_assigned: "User grade assigned",
        user_updated: "User updated",
        w12_report_date_set: "Report date set",
        w13_delete: "Audit trail entry deleted",
        // K4 — Review action labels (audit trail on Review engagements).
        review_page_enabled: "Review page enabled",
        review_page_disabled: "Review page disabled",
        review_precondition_updated: "W17.1 precondition updated",
        review_w17_1_signed_off: "W17.1 Acceptance signed off",
        review_w17_1_signoff_date_changed: "W17.1 Acceptance sign-off date changed",
        review_w17_1_terms_agreed: "W17.1 Terms agreed",
        review_w17_2_field_saved: "W17.2 Understanding field saved",
        review_w17_2_likely_area_added: "W17.2 Likely-misstatement area added",
        review_w17_2_likely_area_removed: "W17.2 Likely-misstatement area removed",
        review_w17_3_row_saved: "W17.3 Analytical row saved",
        review_w17_3_likely_covered: "W17.3 Likely-area coverage updated",
        review_w17_4_inquiry_answered: "W17.4 Inquiry answered",
        review_w17_5_saved: "W17.5 Specific procedures saved",
        review_w17_5_concluded: "W17.5 Specific procedures concluded",
        review_w17_6_field_saved: "W17.6 Reconciliation field saved",
        review_w17_6_concluded: "W17.6 Reconciliation concluded",
        review_w17_7_entry_added: "W17.7 Additional procedures — entry added",
        review_w17_7_entry_patched: "W17.7 Additional procedures — entry updated",
        review_w17_7_sent_to_misstatements: "W17.7 Additional procedures — sent to misstatements",
        review_w17_8_saved: "W17.8 Conclusion saved",
        review_w17_8_preparer_signed: "W17.8 Preparer signed",
        review_w17_8_reviewer_signed: "W17.8 Reviewer signed",
        review_w17_8_partner_signed: "W17.8 Partner signed",
      },
      entity: {
        // T2 · 311(a) — nested inside w13.entity so entityLabel() picks it up.
        tcwg_311a_log: "311(a) communication log",
        form: "Form",
        engagement_forms: "Form",
        a9001_je_population: "JE-testing population (A9001)",
        aging_ar: "Aging (AR)",
        ai_cost_rate: "AI cost rate",
        ai_key: "AI key",
        ai_key_request: "AI key request",
        attachment: "Attachment",
        billing_grade: "Billing grade",
        coa_mappings: "Chart-of-accounts mappings",
        completeness_listing: "Completeness listing",
        completeness_row: "Completeness row",
        completeness_worksheet: "Completeness worksheet",
        confirmation: "Confirmation",
        continuous_preset: "Continuous preset",
        custom_fs_code: "Custom FS code",
        discrepancies: "Discrepancies",
        discrepancy: "Discrepancy",
        discrepancy_resolution: "Discrepancy resolution",
        document: "Document",
        engagement: "Engagement",
        estimate_worksheet: "Estimate worksheet",
        form: "Form",
        forms: "Forms",
        gl_batch: "GL batch",
        gl_entry: "GL entry",
        gl_headwise: "GL head-wise",
        head_folder_assignment: "Head-folder assignment",
        head_folder_worksheet: "Head-folder worksheet",
        inventory_count_worksheet: "Inventory-count worksheet",
        materiality: "Materiality",
        materiality_figures: "Materiality figures",
        misstatement: "Misstatement",
        misstatements_summary: "Misstatements summary",
        observation: "Observation",
        organization: "Organization",
        orphan_sweep_report: "Orphan-sweep report",
        other_cost: "Other cost",
        related_party_row: "Related-party row",
        related_party_worksheet: "Related-party worksheet",
        response_plan: "Response plan",
        review_point: "Review point",
        review_point_permission: "Review-point permission",
        sample: "Sample",
        scoping_row: "Scoping row",
        storage_reconciliation: "Storage reconciliation",
        tab: "Tab",
        tb_direct: "TB (direct)",
        time_entry: "Time entry",
        user: "User",
        user_language: "User language",
        vouching_item: "Vouching item",
        vouching_sheet: "Vouching sheet",
        w9_signoff: "W9 sign-off",
        w10_signoff: "Audit summary memo sign-off",   // Batch 15 · N3
        walkthrough_seed: "Walkthrough seed",
        worksheet: "Worksheet",
        risk_item: "Risk item",
        control_deficiency: "Control deficiency",
        signoff: "Sign-off",
        bundle: "Bundle",
        // K4 — Review-engagement entity types.
        review_page: "Review page",
        review_w17_1: "W17.1 Acceptance",
        review_w17_2: "W17.2 Understanding",
        review_w17_3: "W17.3 Analytical procedures",
        review_w17_4: "W17.4 Inquiries",
        review_w17_5: "W17.5 Specific procedures",
        review_w17_6: "W17.6 Reconciliation",
        review_w17_7: "W17.7 Additional procedures",
        review_w17_8: "W17.8 Conclusion",
      },
      role: {
        admin: "Admin",
        "assistant manager": "Assistant Manager",
        "audit manager": "Audit Manager",
        auditor: "Auditor",
        eqc: "EQ reviewer",
        manager: "Manager",
        partner: "Partner",
        "platform admin": "Platform Admin",
        preparer: "Preparer",
        // K4 — Review engagements use "Practitioner" not "Reviewer" for
        // the engagement team (ISRE 2400 (Revised) vocabulary).
        practitioner: "Practitioner",
        reviewer: "Reviewer",
        "senior manager": "Senior Manager",
        supervisor: "Supervisor",
        system: "System",
      },
    },
  },
  ar: {
    w13: {
      title: "سجل التدقيق", subtitle: "كل إجراء على هذه المهمة (\u2066W13\u2069).",
      entityDeleted: "(محذوف)",
      retention: "مدة الاحتفاظ بسجل التدقيق",
      retentionYears: "{n} سنة/سنوات",
      retentionNotSet: "غير مُعيَّنة — لم يُحدِّد مسؤول الشركة مدة الاحتفاظ بعد. لا يحذف التطبيق شيئًا تلقائيًا.",
      filters: "المرشحات",
      f: { user: "المستخدم", userAll: "كل المستخدمين",
             action: "الإجراء", actionAll: "كل الإجراءات",
             ref: "المرجع / معرِّف الكيان",
             from: "من تاريخ", to: "إلى تاريخ", search: "بحث" },
      rowCount: "{n} سجل",
      exportXlsx: "تصدير \u2066.xlsx\u2069", exportCsv: "تصدير \u2066.csv\u2069",
      exportedOk: "تم تصدير {n} سجل.",
      reasonPrompt: "سبب حذف هذا القيد من سجل التدقيق (مطلوب):",
      deletedOk: "تم حذف القيد.",
      noRows: "لا سجلات تطابق المرشحات.",
      deletionsTitle: "القيود المحذوفة (عرض الشريك)",
      h: { at: "التوقيت", user: "المستخدم", role: "الدور", action: "الإجراء",
             entity: "الكيان", actions: "",
             deletedAt: "تاريخ الحذف", by: "بواسطة", reason: "السبب",
             entrySnap: "القيد الأصلي" },
      changedAfterSigning: "تغيّر سجل التدقيق بعد التوقيع",
      changedAfterSigningDetail: "تم حذف {n} من قيود سجل التدقيق التي يغطيها هذا الملف الموقَّع بعد تاريخ التوقيع.",
      action: {
        // T2 · 311(a) — see EN block above.
        tcwg_311a_log_added: "أُضيف صف سجل \u2066311(a)\u2069",
        tcwg_311a_log_patched: "عُدِّل صف سجل \u2066311(a)\u2069",
        tcwg_311a_log_backfilled: "تعبئة تلقائية — فشل الكتابة الأصلية",
        tcwg_311a_migrated_from_form: "استُرد صف من نموذج \u2066311(a)\u2069",
        tcwg_311a_na_set: "تم اعتبار التواصل مع المكلفين بالحوكمة غير مُطبَّق",
        tcwg_311a_na_cleared: "أُلغي اعتبار التواصل غير مُطبَّق",
        form_na_toggled: "تبديل غير منطبق للنموذج",
        ai_cost_rate_updated: "تحديث تكلفة الذكاء الاصطناعي",
        ai_key_issued: "إصدار مفتاح ذكاء اصطناعي",
        ai_key_requested: "طلب مفتاح ذكاء اصطناعي",
        ai_key_rotated: "تدوير مفتاح الذكاء الاصطناعي",
        amended: "عُدِّل",
        assembly_complete: "اعتماد اكتمال التجميع",
        assertion_bypassed: "تجاوز التأكيد",
        assertion_cleared: "إلغاء التأكيد",
        assertion_ticked: "اعتماد التأكيد",
        bulk_ai_suggested: "اقتراحات ذكاء اصطناعي جماعية",
        bypassed_missing_doc: "تجاوز مستند مفقود",
        cleared_bypass: "إلغاء التجاوز",
        confirmation_created: "إنشاء مصادقة",
        confirmation_deleted: "حذف مصادقة",
        confirmation_updated: "تحديث مصادقة",
        continuous_preset_created: "إنشاء إعداد مستمر",
        continuous_preset_deleted: "حذف إعداد مستمر",
        created: "أُنشئ",
        deduped_population: "إزالة تكرار المجتمع",
        deleted: "حُذف",
        engagement_member_added: "إضافة عضو للمهمة",
        engagement_member_removed: "إزالة عضو من المهمة",
        flagged_test_entry: "تعليم قيد اختباري",
        form_added_to_engagement: "إضافة نموذج للمهمة",
        form_ai_suggested: "اقتراح نموذج بالذكاء الاصطناعي",
        form_approved: "اعتماد النموذج",
        form_deleted_permanent: "حذف نموذج نهائيًا",
        form_draft: "نموذج مسودّة",
        form_na_toggled: "تبديل غير منطبق",
        form_ready_for_review: "نموذج جاهز للمراجعة",
        form_updated: "تحديث النموذج",
        forms_batch_added: "إضافة نماذج دفعةً",
        forms_rolled_forward: "ترحيل النماذج",
        "fs_custom_code.created": "إنشاء بند قوائم مخصص",
        fs_mapping_clear: "مسح تعيين القوائم",
        fs_mapping_import: "استيراد تعيين القوائم",
        grade_created: "إنشاء درجة فوترة",
        grade_deleted: "حذف درجة فوترة",
        imported: "استُورد",
        invited: "دُعي",
        linked: "رُبط",
        member_budget_updated: "تحديث موازنة العضو",
        migrated: "مُرحَّل",
        moved: "نُقل",
        note_mapping_clear: "مسح تعيين الإيضاح",
        opened_worksheet: "فُتحت ورقة العمل",
        closed_worksheet: "أُغلقت ورقة العمل",
        orphan_sweep_report: "تقرير مسح اليتيم",
        other_cost_created: "إنشاء تكلفة أخرى",
        password_reset_completed: "اكتمل إعادة تعيين كلمة المرور",
        password_reset_requested: "طلب إعادة تعيين كلمة المرور",
        plan_changed: "تغيير الباقة",
        platform_admin_list_engagements: "استعراض المهام بواسطة مسؤول المنصّة",
        post_assembly_amendment: "تعديل بعد تجميع الملف",
        ran_detection: "تشغيل الاكتشاف",
        rate_updated: "تحديث السعر",
        renumbered: "أُعيد ترقيمه",
        rerun: "إعادة تشغيل",
        resampled: "إعادة أخذ عينة",
        review_point_cleared: "اعتماد نقطة المراجعة",
        review_point_comment_added: "إضافة تعليق نقطة مراجعة",
        review_point_created: "إنشاء نقطة مراجعة",
        review_point_deleted: "حذف نقطة مراجعة",
        review_point_in_progress: "نقطة مراجعة قيد التنفيذ",
        review_point_permission_granted: "منح صلاحية نقاط المراجعة",
        review_point_reopened: "إعادة فتح نقطة مراجعة",
        review_point_resolved: "حل نقطة مراجعة",
        roles_renamed: "تعديل مسميات الأدوار",
        seeded: "زُرع",
        sent: "أُرسل",
        sent_to_misstatements: "أُرسل إلى التحريفات",
        sent_to_sampling: "أُرسل إلى أخذ العينات",
        signed_off: "تم التوقيع",
        unlocked: "أُلغي القفل",
        stage_signoff_eqc: "توقيع مرحلة \u2066مراجع الجودة\u2069",
        dc_ai_premark_queued: "بدء التعليم المسبق لقائمة الإفصاحات", ai_readout_queued: "بدء القراءة بالذكاء الاصطناعي", risk_ai_suggest_queued: "بدء اقتراح المخاطر",
        dc_fs_uploaded: "رفع القوائم المالية لقائمة الإفصاحات", aging_ap: "رفع أعمار الذمم الدائنة", aging_ar: "رفع أعمار الذمم المدينة",
        head_folder_worksheet_pye: "إضافة ورقة عمل نهاية الفترة إلى مجلد البند", dc_scoped_out: "إخراج من نطاق قائمة الإفصاحات", dc_scope_reverted: "إعادة نطاق قائمة الإفصاحات",
        bulk_ai_suggested: "تشغيل اقتراح الذكاء الاصطناعي للنماذج", dc_ai_premark_withdrawn_non_fs: "سحب اقتراحات التعليم المسبق (غير مستندة للقوائم)",
        stage_signoff_partner: "توقيع مرحلة الشريك",
        stage_signoff_preparer: "توقيع مرحلة المُعِدّ",
        stage_signoff_reviewer: "توقيع مرحلة المراجع",
        storage_reconcile_started: "بدء مطابقة التخزين",
        tenant_byok_permission_toggled: "تبديل صلاحية \u2066BYOK\u2069",
        tenant_created: "إنشاء المستأجر",
        tested: "اختُبر",
        time_entry_deleted: "حذف قيد وقت",
        time_entry_edited: "تعديل قيد وقت",
        time_manual_added: "إضافة قيد وقت يدوي",
        undone: "تراجع",
        untested: "لم يُختبر",
        update: "تحديث",
        updated: "حُدِّث",
        uploaded: "رُفع",
        upserted: "إدراج/تحديث",
        user_grade_assigned: "تعيين درجة للمستخدم",
        user_updated: "تحديث المستخدم",
        w12_report_date_set: "تم تحديد تاريخ التقرير",
        w13_delete: "حُذف قيد من سجل التدقيق",
        // K4 — Review action labels (Arabic).
        review_page_enabled: "تفعيل صفحة فحص",
        review_page_disabled: "تعطيل صفحة فحص",
        review_precondition_updated: "تحديث شرط مسبق \u2066W17.1\u2069",
        review_w17_1_signed_off: "توقيع القبول \u2066W17.1\u2069",
        review_w17_1_signoff_date_changed: "تغيير تاريخ توقيع \u2066W17.1\u2069",
        review_w17_1_terms_agreed: "الموافقة على شروط \u2066W17.1\u2069",
        review_w17_2_field_saved: "حفظ حقل فهم المنشأة \u2066W17.2\u2069",
        review_w17_2_likely_area_added: "إضافة مجال محتمل للتحريف \u2066W17.2\u2069",
        review_w17_2_likely_area_removed: "إزالة مجال محتمل للتحريف \u2066W17.2\u2069",
        review_w17_3_row_saved: "حفظ صف تحليلي \u2066W17.3\u2069",
        review_w17_3_likely_covered: "تحديث تغطية المجالات المحتملة \u2066W17.3\u2069",
        review_w17_4_inquiry_answered: "الإجابة عن استفسار \u2066W17.4\u2069",
        review_w17_5_saved: "حفظ إجراءات محددة \u2066W17.5\u2069",
        review_w17_5_concluded: "استنتاج إجراءات محددة \u2066W17.5\u2069",
        review_w17_6_field_saved: "حفظ حقل مطابقة \u2066W17.6\u2069",
        review_w17_6_concluded: "استنتاج المطابقة \u2066W17.6\u2069",
        review_w17_7_entry_added: "إضافة قيد إجراءات إضافية \u2066W17.7\u2069",
        review_w17_7_entry_patched: "تحديث قيد إجراءات إضافية \u2066W17.7\u2069",
        review_w17_7_sent_to_misstatements: "إرسال قيد إجراءات إضافية إلى التحريفات \u2066W17.7\u2069",
        review_w17_8_saved: "حفظ استنتاج \u2066W17.8\u2069",
        review_w17_8_preparer_signed: "توقيع المُعِدّ \u2066W17.8\u2069",
        review_w17_8_reviewer_signed: "توقيع المراجع \u2066W17.8\u2069",
        review_w17_8_partner_signed: "توقيع الشريك \u2066W17.8\u2069",
      },
      entity: {
        // T2 · 311(a) — nested here so entityLabel() picks it up.
        tcwg_311a_log: "سجل اتصالات \u2066311(a)\u2069",
        form: "نموذج",
        engagement_forms: "نموذج",
        a9001_je_population: "مجتمع قيود اليومية (\u2066A9001\u2069)",
        aging_ar: "أعمار الذمم المدينة",
        ai_cost_rate: "تكلفة الذكاء الاصطناعي",
        ai_key: "مفتاح الذكاء الاصطناعي",
        ai_key_request: "طلب مفتاح ذكاء اصطناعي",
        attachment: "مرفق",
        billing_grade: "درجة الفوترة",
        coa_mappings: "تعيينات دليل الحسابات",
        completeness_listing: "قائمة الاكتمال",
        completeness_row: "بند اكتمال",
        completeness_worksheet: "ورقة عمل الاكتمال",
        confirmation: "مصادقة",
        continuous_preset: "إعداد مستمر",
        custom_fs_code: "بند قوائم مخصص",
        discrepancies: "الفروقات",
        discrepancy: "فرق",
        discrepancy_resolution: "تسوية فرق",
        document: "مستند",
        engagement: "المهمة",
        estimate_worksheet: "ورقة عمل التقديرات",
        form: "نموذج",
        forms: "النماذج",
        gl_batch: "دفعة أستاذ",
        gl_entry: "قيد أستاذ",
        gl_headwise: "أستاذ بحسب البنود",
        head_folder_assignment: "إسناد مجلد بند",
        head_folder_worksheet: "ورقة مجلد بند",
        inventory_count_worksheet: "ورقة جرد المخزون",
        materiality: "الأهمية النسبية",
        materiality_figures: "أرقام الأهمية النسبية",
        misstatement: "تحريف",
        misstatements_summary: "ملخص التحريفات",
        observation: "ملاحظة",
        organization: "المؤسسة",
        orphan_sweep_report: "تقرير مسح اليتيم",
        other_cost: "تكلفة أخرى",
        related_party_row: "بند طرف ذي علاقة",
        related_party_worksheet: "ورقة الأطراف ذات العلاقة",
        response_plan: "خطة الاستجابة",
        review_point: "نقطة مراجعة",
        review_point_permission: "صلاحية نقطة مراجعة",
        sample: "عيّنة",
        scoping_row: "بند نطاق",
        storage_reconciliation: "مطابقة التخزين",
        tab: "تبويب",
        tb_direct: "ميزان مباشر",
        time_entry: "قيد وقت",
        user: "مستخدم",
        user_language: "لغة المستخدم",
        vouching_item: "بند وثيقة",
        vouching_sheet: "ورقة وثائق",
        w9_signoff: "توقيع \u2066W9\u2069",
        w10_signoff: "توقيع مذكرة ملخص المراجعة",   // Batch 15 · N3
        walkthrough_seed: "بذرة تجوال",
        worksheet: "ورقة عمل",
        risk_item: "بند مخاطر",
        control_deficiency: "قصور رقابي",
        signoff: "توقيع",
        bundle: "حزمة",
        // K4 — Review-engagement entity types (Arabic).
        review_page: "صفحة فحص",
        review_w17_1: "\u2066W17.1\u2069 قبول الارتباط",
        review_w17_2: "\u2066W17.2\u2069 فهم المنشأة",
        review_w17_3: "\u2066W17.3\u2069 الإجراءات التحليلية",
        review_w17_4: "\u2066W17.4\u2069 الاستفسارات",
        review_w17_5: "\u2066W17.5\u2069 إجراءات محددة",
        review_w17_6: "\u2066W17.6\u2069 المطابقة",
        review_w17_7: "\u2066W17.7\u2069 إجراءات إضافية",
        review_w17_8: "\u2066W17.8\u2069 الاستنتاج",
      },
      role: {
        admin: "مسؤول",
        "assistant manager": "مساعد مدير",
        "audit manager": "مدير مراجعة",
        auditor: "مراجع",
        eqc: "مراجع جودة المهمة",
        manager: "مدير",
        partner: "شريك",
        "platform admin": "مسؤول المنصّة",
        preparer: "مُعِدّ",
        // K4 — Reviews use "Practitioner" (ISRE 2400) not "Reviewer".
        practitioner: "ممارس",
        reviewer: "مراجع الجودة",
        "senior manager": "مدير أول",
        supervisor: "مشرف",
        system: "النظام",
      },
    },
  },
};

export default I18N_BASE_W13;
